import React, { useEffect, useRef, useState } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { list, add, deleteStaff, edit, detail, changeStatus} from "../../../services/spice-levels.service";
import { ACTIVE, DEACTIVE, LANG_OPTIONS, LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import {  capitalizeFirstLetter, globalLoader, handleOffcanvasScroll, handleServerValidations, TrimText, useDebouncing } from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSafeNavigate } from "../../../../../utils/useSafeNavigate";
import RecordNotFound from "../../../shared/recordNotFound";
import { Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../../admin/common/custompagination";


export default function SpiceLevels() {
  const navigate = useSafeNavigate()
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation();
  const {i18n} = useTranslation();
  const [List, setList] = useState([]);
  const { spiceAddValidationSchema, spiceEditValidationSchema } = useValidationSchemas();
  const addCategoryCloseBtn = useRef();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [loader, setLoader] = useState(true);
  const [spiceLevelDetail, setSpiceLevelDetail] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [attendance, setAttendance] = useState([]);
  const [attendanceLoader, setAttendanceLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(10);
  const [employeeId, setEmployeeId] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const fileSelectInput = useRef();
  const [attendancePage, setAttendancePage] = useState(1);
  const [attendanceOffset, setAttendanceOffset] = useState(0);
  const [attendanceTotalRecords, setAttendanceTotalRecords] = useState(0);
  const toggleEyeIcon = () => {
    showPassword ? setShowPassword(false) : setShowPassword(true);
  };

  // State for search input and select dropdown
  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [sortConfig, setSortConfig] = useState({ column: 'createdAt', order: SORT_D });
  const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: 'date', order: SORT_D });
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const prepareGlobalSearch = (value) => {
    setPrevGlobalSearch(globalSearch)
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  const handleFilterStatusChange = (e) => {
    if (e.target.value) {
      prepareSearch("status", Number(e.target.value));
    } else {
      prepareSearch("status", "");
    }
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    searchDebounce(value);
  };

  // Handle select dropdown change
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value);
    handleFilterStatusChange(e);
  };

  // Reset filter values
  const resetFilter = (e) => {
    setSearchValue('');
    setSelectedStatus('');
    e.preventDefault()
    setGlobalSearch("")
    prepareSearch()
    setSearch({})
  };


  const handleSort = (key) => {
    let direction = SORT_A;
    if (sortConfig.column === key && sortConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortConfig({ column: key, order: direction });
  };


  useEffect(() => {
      const formData = new FormData();
      if (Object.keys(search).length) {
        formData.append("search", JSON.stringify(search));
      }
      formData.append("global_search", globalSearch);
      // Determine the page number
      let page = params.page;
      if (globalSearch) {
        if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
          page = 1; // Reset to the first page if globalSearch changes
        }
        setPage(page);
      }
      formData.append("page", page);
      formData.append("per_page", itemPerPage);
      if (sortConfig) {
        formData.append("sort", JSON.stringify(sortConfig));
      }
      list(formData)
        .then((data) => {
          if (data && data.data) {
            setList(data.data.list || []);
            setPage(data.data.page);
            navigate(`/restaurant/settings/spice-level/${data.data.page}`);
            setOffsetPage(data.data.offset);
            setTotalRecords(data.data.total_records || 0);
          } else {
            setList([]);
            setOffsetPage(0);
            setTotalRecords(0);
          }
          setPrevGlobalSearch(globalSearch);
          setTimeout(() => {
            setLoader(false);
          }, LOADER_TIMEOUT_TIME);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setTimeout(() => {
            setLoader(false);
          }, LOADER_TIMEOUT_TIME);
        });
  }, [search, refreshList, globalSearch, params.page, sortConfig]);


  const getSpiceLevelDetail = (item) => {
    detail({ o_id: item._id })
      .then((response) => {
        editForm.setValues({
          o_id: response?.data?._id || "",
          name: response?.data?.name || "",
          name_ja: response?.data?.name_ja || "",
        });
        setSpiceLevelDetail(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const addForm = useFormik({
    initialValues: {
      name: "",
      name_ja: ""
    },
    validationSchema: spiceAddValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("name", values.name.toLocaleLowerCase());
      formData.append("name_ja", values.name_ja.toLocaleLowerCase());
      setAddSubmissionLoader(true);
      add(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });

  const editForm = useFormik({
    initialValues: {
      o_id: "",
      name: "",
      name_ja: ""
    },
    validationSchema: spiceEditValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      setEditSubmissionLoader(true);
      const formData = new FormData();
      formData.append("o_id", spiceLevelDetail._id);
      formData.append("name", values.name.toLocaleLowerCase());
      formData.append("name_ja", values.name_ja.toLocaleLowerCase());
      edit(formData)
        .then((response) => {
          setEditSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setEditSubmissionLoader(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });


  const deleteRecord = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteStaff({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
      }
    });
  };

  const changeStatusToggle = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: item.status ? t("btn_deactive_status") : t("btn_active_status"),
      // imageUrl: trash,
      icon:'question',
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: item.status ? t("btn_inactive") : t("btn_active"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        changeStatus({ o_id: item._id, status: item.status ? DEACTIVE : ACTIVE })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">{t("label_spice_level")}  ({totalRecords})</h4>
        </div>
        <div className="card-outer-header restaurant-list-toolbar mb-4">
          <div className="search-box">
            <input
              type="text"
              value={searchValue} // Bind state value
              className="form-control search-input"
              placeholder={t("input_placeholder_search")}
              onChange={handleSearchChange} // Use onChange instead of onInput for better performance
            />
          </div>
          <div className="tabls-dowpdown">
            <select
              className="form-control cp"
              value={selectedStatus} // Bind state value
              onChange={handleSelectChange}
            >
              <option disabled="" value="">
                {t("label_all")}
              </option>
              <option value="1"> {t("btn_active")}</option>
              <option value="0">{t("btn_inactive")}</option>
            </select>
          </div>
          <button
            className="btn btn-primary restaurant-list-toolbar-action"
            onClick={() => {
              setOpenWithHeader(true);
            }}
          >
            <i className="ti ti-plus"></i> {t("label_create_new")}
          </button>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : List?.length ? (
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{t("s_no")}</th>
                          <th>{t("list_name")}
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                              <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '5px' }}></i>
                              <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '-8px' }} />
                            </span>
                          </th>
                                   <th>{t("list_name_japanese")}
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name_ja')}>

                              <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name_ja' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '5px' }}></i>
                              <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name_ja' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                style={{ marginLeft: '-8px' }} />
                            </span>
                          </th>
                          <th>{t("list_heading_status")}</th>
                          <th style={{ width: "150px" }}>{t("label_action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {List.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{offset + index + 1}</td>
                              <td>{capitalizeFirstLetter(TrimText(item?.name, 30))}</td>
                              <td>{capitalizeFirstLetter(TrimText(item?.name_ja, 30))}</td>
                              <td>
                                <div className="mai-card-right">
                                  <div className="form-check form-switch">
                                    <input className="form-check-input cp" type="checkbox" checked={item?.status} onChange={(e) => changeStatusToggle(item)} />
                                  </div>
                                </div>
                              </td>
                              <td className="d-flex">
                                <div className="dropdown ms-2">
                                  <button className="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="ti ti-dots-vertical"></i>
                                  </button>
                                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                      <a
                                        className="dropdown-item cp"
                                        onClick={() => {
                                          getSpiceLevelDetail(item);
                                        }}
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#view-staff"
                                      >
                                        <i className="ti ti-eye"></i>
                                        {t("btn_view")}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="dropdown-item cp"
                                        onClick={() => {
                                          getSpiceLevelDetail(item);
                                          setOpenWithHeaderEdit(true);
                                        }}
                                      >
                                        <i className="ti ti-edit"></i>
                                        {t("btn_edit")}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="dropdown-item cp"
                                        onClick={() => {
                                          deleteRecord(item);
                                        }}
                                      >
                                        <i className="ti ti-trash"></i>
                                        {t("btn_delete")}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="table-status-info d-flex justify-content-between align-items-center">
                    <span>{t("label_showing_entries", { shown: offset + List.length, total: totalRecords })}</span>
                    <nav aria-label="Page navigation example" title={page}>
                      {totalRecords && totalRecords > 0 ?
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[{ name: "settings", path: "/restaurant/settings/spice-level" }]} /> : ""
                      }
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_staff_found" />
            )}
          </div>
        </div>
        <div>
          {/* <button className='btn btn-success' data-bs-toggle="offcanvas" data-bs-target="#view-staff">view staff details</button>
                    <button className='btn btn-danger ms-2' data-bs-toggle="modal" data-bs-target="#shift-history">view staff details</button> */}
        </div>
      </div>

      {/* add item modal  */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("create_spice_levels")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeader(false);
                addForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editNewEmail", "rsuite");
          }}
        >
          <form onSubmit={addForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("list_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("list_name_placeholder")}
                name="name"
                value={addForm?.values?.name}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="name" form={addForm} className="text-danger" />
            </div>
             <div className="mb-3">
              <label className="form-label">
                {t("list_name_japanese")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("list_name_ja_placeholder")}
                name="name_ja"
                value={addForm?.values?.name_ja}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="name_ja" form={addForm} className="text-danger" />
            </div>
            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100"+(addSubmissionLoader?" btn-loader":"")}>
                {t("btn_submit")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>


      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("edit_spice_levels")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderEdit(false);
                editForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editEmail", "rsuite");
          }}
        >
          <form onSubmit={editForm.handleSubmit}>

            {/* Name */}
           <div className="mb-3">
              <label className="form-label">
                {t("list_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("list_name_placeholder")}
                name="name"
                value={editForm?.values?.name}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError name="name" form={editForm} className="text-danger" />
            </div>
             <div className="mb-3">
              <label className="form-label">
                {t("list_name_japanese")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("list_name_ja_placeholder")}
                name="name_ja"
                value={editForm?.values?.name_ja}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError name="name_ja" form={editForm} className="text-danger" />
            </div>
            {/* Submit Button */}
            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100"+(editSubmissionLoader?" btn-loader":"")}>
                {t("btn_submit")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            {t("view_spice_levels_details")}
          </h5>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="view-staff-info">
            <div className="row gap-4">
              <div className="col-md-12">
                <h4>{t("list_name")}</h4>
                <p>{capitalizeFirstLetter(spiceLevelDetail?.name)}</p>
              </div>
               <div className="col-md-12">
                <h4>{t("list_name_japanese")}</h4>
                <p>{capitalizeFirstLetter(spiceLevelDetail?.name_ja)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
